import { getOurClassesService } from "../api/landingClass.service";

const CACHE_TTL_MS = 5 * 60 * 1000;

let level1ByLevel2Cache: Map<string, string> | null = null;
let cacheExpiresAt = 0;

export function invalidateLevel1LookupCache(): void {
  level1ByLevel2Cache = null;
  cacheExpiresAt = 0;
}

async function loadLevel1ByLevel2Lookup(): Promise<Map<string, string>> {
  if (level1ByLevel2Cache && Date.now() < cacheExpiresAt) {
    return level1ByLevel2Cache;
  }

  const lookup = new Map<string, string>();
  const response = await getOurClassesService();

  for (const category of response.data ?? []) {
    for (const level of category.our_levels ?? []) {
      lookup.set(level.id, category.id);
    }
  }

  level1ByLevel2Cache = lookup;
  cacheExpiresAt = Date.now() + CACHE_TTL_MS;
  return lookup;
}

/** Resolves parent level1 id for a level2 id (URL hint preferred, then our-classes lookup). */
export async function resolveLevel1IdForLevel2(
  level2Id: string,
  hintLevel1Id?: string
): Promise<string | null> {
  const hinted = hintLevel1Id?.trim();
  if (hinted) return hinted;
  if (!level2Id) return null;

  let lookup = await loadLevel1ByLevel2Lookup();
  const cached = lookup.get(level2Id);
  if (cached) return cached;

  // Retry once with a fresh lookup when catalog structure may have changed.
  invalidateLevel1LookupCache();
  lookup = await loadLevel1ByLevel2Lookup();
  return lookup.get(level2Id) ?? null;
}
